/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import "./MyInbox.scss";
import {
  Box,
  Container,
  Grid,
  Typography,
  Stack,
  Pagination,
} from "@mui/material";
import { connect } from "react-redux";
import { FetchMatchInvite, fetchUserStats } from "../../Store/Actions/matchesActionCreator";
import InboxUserCard from "../../Components/Cards/InboxUserCard";
import { Spinner } from "../../Components/UI";
import { EmptyImage } from "../../Assets/svg";
import { INVITE_STATUS_ENUM } from "../../Utils/constants";
import { showMessage } from "../../Utils/helper";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function MyInbox({
  user,
  dispatchFetchMatchInvite,
  dispatchFetchUserStats,
  ...props
}) {
  const [stats, setStats] = React.useState({});
  const mountedRef = React.useRef(true);
  React.useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);
  const filterInfo = {
    ...(props?.location?.state?.filterInfo ?? {}),
  };
  const [value, setValue] = React.useState(
    ...(filterInfo?.type === "sent" ? "2" : "1")
  );
  const [loading, setLoading] = React.useState(false);
  const [filterPayload, setFilterPayload] = React.useState({
    type: "received",
    category: "",
    ...filterInfo,
  });
  const [inviteResp, setInviteResp] = React.useState({ matchData: [] });
  const [invites, setInvites] = React.useState({
    [INVITE_STATUS_ENUM.SENT]: [],
    // [INVITE_STATUS_ENUM.RECEIVED]: [],
    [INVITE_STATUS_ENUM.ACCEPTED]: [],
    [INVITE_STATUS_ENUM.USER_ACCEPTED]: [],
    [INVITE_STATUS_ENUM.SYSTEM_ACCEPTED]: [],
    [INVITE_STATUS_ENUM.REJECTED]: [],
    [INVITE_STATUS_ENUM.SYSTEM_REJECTED]: [],
  });

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setFilterPayload({
      ...filterPayload,
      type: newValue === "1" ? "received" : "sent",
      category: "",
      page: 1,
    });
    setInviteResp({ matchData: [] });
  };

  const fetchInvites = (filters = {}) => {
    setLoading(true);
    const payload = { ...filterPayload, ...filters };
    dispatchFetchMatchInvite(
      payload,
      (resp) => {
        if (resp?.status) {
          setInviteResp(resp?.result ?? {});
          let newInvtes = { ...invites };
          Object.keys(newInvtes).forEach((item) => {
            newInvtes = {
              ...newInvtes,
              [item]: resp?.result?.matchData?.filter(
                (i) => i.invitationStatus === item
              ),
            };
          });

          setInvites(newInvtes);
          setLoading(false);
          dispatchFetchUserStats(
            (r) => r?.status && mountedRef.current && setStats(r?.result ?? {}),
            () => {}
          );
        } else {
          showMessage(resp?.result, "error");
          setLoading(false);
        }
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  useEffect(() => {
    window.scrollTo({
      x: 0,
      y: 0,
    });
    fetchInvites({
      category:
        filterPayload?.category === "all" ? "" : filterPayload?.category,
    });
  }, [filterPayload]);

  const pageNo = Number(inviteResp?.page ?? 0);

  const CardGrid = ({ item, type }) => {
    return (
      <Grid item className="inboxlist" padding={0} paddingBottom="1rem">
        <InboxUserCard
          type={type}
          fetchInvites={fetchInvites}
          setCategoryType={(val) => {
            setFilterPayload({
              ...filterPayload,
              category: val,
            });
          }}
          filterPayload={filterPayload}
          data={{ ...item }}
        />
      </Grid>
    );
  };
  const num = (n) => (isNaN(n) ? 0 : Number(n));
  const summarize = (key) => {
    const st = stats?.[key] ?? {};
    const pending = num(st.SENT);
    const accepted = num(st.USER_ACCEPTED) + num(st.SYSTEM_ACCEPTED);
    const declined = num(st.REJECTED) + num(st.SYSTEM_REJECTED);
    return { pending, accepted, declined, total: pending + accepted + declined };
  };
  const received = summarize("RECEIVED");
  const sent = summarize("SENT");
  const current = value === "1" ? received : sent;
  const pad = (n) => String(n).padStart(2, "0");
  const setCategory = (category) =>
    setFilterPayload({ ...filterPayload, category, page: 1 });
  const statusChips = [
    { key: "", label: "All", count: current.total, cls: "all" },
    { key: "SENT", label: "Pending", count: current.pending, cls: "pending" },
    {
      key: "ACCEPTED",
      label: "Accepted",
      count: current.accepted,
      cls: "accepted",
    },
    {
      key: "REJECTED",
      label: "Declined",
      count: current.declined,
      cls: "declined",
    },
  ];
  const filterByInput = (
    <div className="inbox-filter">
      <div className="inbox-filter-title">Filter by status</div>
      <div className="inbox-chips">
        {statusChips.map((c) => (
          <button
            type="button"
            key={c.label}
            className={`inbox-chip ${c.cls} ${
              (filterPayload?.category || "") === c.key ? "active" : ""
            }`}
            onClick={() => setCategory(c.key)}
          >
            {c.label} {c.count}
          </button>
        ))}
      </div>
    </div>
  );
  return (
    <Spinner loading={loading}>
      <div id="MyInbox" className="myinbox">
        <Container className="base-container" maxWidth="unset">
          <div className="maindivinbox">
            {!user?.prime && (
              <div className="inbox-prime-banner">
                <div className="inbox-prime-banner-text">
                  <h3>
                    Get contact details immediately after sending the invite,
                    chat, shortlist / block profiles and much more
                  </h3>
                  <p>Donate Rs. 1000/- or more to upgrade.</p>
                </div>
                <button
                  type="button"
                  className="inbox-prime-banner-btn"
                  onClick={() => props.history.push("/my-account")}
                >
                  Upgrade To VVS Prime
                </button>
              </div>
            )}
            <div className="inbox-header">
              <div className="inbox-title-row">
                <div>
                  <h1 className="inbox-title">My Inbox</h1>
                  <div className="inbox-subtitle">
                    Manage invitations you've received and sent.
                  </div>
                </div>
                <span className="inbox-total-pill">
                  {received.total + sent.total} requests
                </span>
              </div>
              <div className="inbox-tiles">
                {[
                  { v: "1", label: "Received", s: received },
                  { v: "2", label: "Sent", s: sent },
                ].map((t) => (
                  <button
                    type="button"
                    key={t.v}
                    className={`inbox-tile ${value === t.v ? "active" : ""}`}
                    onClick={() => value !== t.v && handleChange(null, t.v)}
                  >
                    <span className="inbox-tile-label">{t.label}</span>
                    <span className="inbox-tile-count">{pad(t.s.total)}</span>
                    <span className="inbox-tile-sub">
                      {t.s.pending} pending
                    </span>
                  </button>
                ))}
              </div>
              <div className={`inbox-info-grid ${user?.prime ? "" : "single"}`}>
                {!!user?.prime && (
                  <div className="inbox-info-card prime">
                    <div className="inbox-info-badge">PRIME</div>
                    <div>
                      <div className="inbox-info-head">
                        You are a VVS PRIME member
                      </div>
                      <div className="inbox-info-text">
                        View contacts of invites you sent. Membership ends on{" "}
                        {user.primeExpiryDate}.
                      </div>
                    </div>
                  </div>
                )}
                <div className="inbox-info-card note">
                  <div className="inbox-info-head">Good to know</div>
                  <div className="inbox-info-text">
                    Invites are auto-declined if no action is taken in 30 days.
                  </div>
                </div>
              </div>
            </div>
            <div className="inbox-header">{filterByInput}</div>
            <TabPanel index="1" value={value}>
              {!inviteResp?.matchData?.length && (
                <Grid className="inboxlist inbox-empty" padding={0}>
                  <EmptyImage width={200} height={200} />
                  <div className="inbox-empty-title">No invites received yet</div>
                  <div className="inbox-empty-sub">
                    When someone expresses interest in your profile, it will
                    show up here.
                  </div>
                </Grid>
              )}
              {!!invites.SENT?.length && (
                <>
                  <Grid className="inboxlist" padding="1rem 0">
                    <Typography
                      color="#515f6d"
                      className="indexnotificationcount"
                    >
                      Pending ({invites.SENT?.length})
                    </Typography>
                  </Grid>
                  {invites.SENT?.map((item) => {
                    return CardGrid({ item, type: "RECEIVED" });
                  })}
                </>
              )}
              {(!!invites.USER_ACCEPTED?.length ||
                !!invites.SYSTEM_ACCEPTED?.length ||
                !!invites.ACCEPTED?.length) && (
                <>
                  <Grid className="inboxlist" padding="1rem 0">
                    <Typography
                      color="#00AA44"
                      className="indexnotificationcount"
                    >
                      Accepted (
                      {invites.ACCEPTED?.length +
                        invites.USER_ACCEPTED?.length +
                        invites.SYSTEM_ACCEPTED?.length}
                      )
                    </Typography>
                  </Grid>
                  {invites.USER_ACCEPTED?.map((item) => {
                    return CardGrid({ item, type: "RECEIVED" });
                  })}
                  {invites.SYSTEM_ACCEPTED?.map((item) => {
                    return CardGrid({ item, type: "RECEIVED" });
                  })}
                </>
              )}
              {(!!invites.REJECTED?.length ||
                !!invites.SYSTEM_REJECTED?.length) && (
                <>
                  <Grid className="inboxlist" padding="1rem 0">
                    <Typography color="red" className="indexnotificationcount">
                      Declined (
                      {invites.REJECTED?.length +
                        invites.SYSTEM_REJECTED?.length}
                      )
                    </Typography>
                  </Grid>
                  {invites.SYSTEM_REJECTED?.map((item) => {
                    return CardGrid({ item, type: "RECEIVED" });
                  })}
                    {invites.REJECTED?.map((item) => {
                    return CardGrid({ item, type: "RECEIVED" });
                  })}
                </>
              )}
            </TabPanel>
            <TabPanel index="2" value={value}>
              {!inviteResp?.matchData?.length && (
                <Grid className="inboxlist inbox-empty" padding={0}>
                  <EmptyImage width={200} height={200} />
                  <div className="inbox-empty-title">No invites sent yet</div>
                  <div className="inbox-empty-sub">
                    Browse your matches and express interest to start a
                    conversation.
                  </div>
                </Grid>
              )}
              {!!invites.SENT?.length && (
                <>
                  <Grid className="inboxlist" padding="1rem 0">
                    <Typography
                      color="#515f6d"
                      className="indexnotificationcount"
                    >
                      Pending ({invites.SENT?.length})
                    </Typography>
                  </Grid>
                  {invites.SENT?.map((item) => {
                    return CardGrid({ item, type: "SENT" });
                  })}
                </>
              )}
              {(!!invites.USER_ACCEPTED?.length ||
                !!invites.SYSTEM_ACCEPTED?.length ||
                !!invites.ACCEPTED?.length) && (
                <>
                  <Grid className="inboxlist" padding="1rem 0">
                    <Typography
                      color="#00AA44"
                      className="indexnotificationcount"
                    >
                      Accepted (
                      {invites.ACCEPTED?.length +
                        invites.USER_ACCEPTED?.length +
                        invites.SYSTEM_ACCEPTED?.length}
                      )
                    </Typography>
                  </Grid>
                  {invites.USER_ACCEPTED?.map((item) => {
                    return CardGrid({ item, type: "SENT" });
                  })}
                  {invites.SYSTEM_ACCEPTED?.map((item) => {
                    return CardGrid({ item, type: "SENT" });
                  })}
                </>
              )}
              {(!!invites.REJECTED?.length ||
                !!invites.SYSTEM_REJECTED?.length) && (
                <>
                  <Grid className="inboxlist" padding="1rem 0">
                    <Typography color="red" className="indexnotificationcount">
                      Declined (
                      {invites.REJECTED?.length +
                        invites.SYSTEM_REJECTED?.length}
                      )
                    </Typography>
                  </Grid>
                  {invites.SYSTEM_REJECTED?.map((item) => {
                    return CardGrid({ item, type: "SENT" });
                  })}
                  {invites.REJECTED?.map((item) => {
                    return CardGrid({ item, type: "SENT" });
                  })}
                </>
              )}
            </TabPanel>
            <Stack
              spacing={2}
              width="22em"
              margin={"2em auto 1em auto"}
              style={{ textAlign: "center" }}
            >
              <Pagination
                count={Math.ceil(
                  Number(inviteResp?.totalCount) / Number(inviteResp?.size) >= 1
                    ? Number(inviteResp?.totalCount) / Number(inviteResp?.size)
                    : 1
                )}
                page={pageNo}
                shape="rounded"
                onChange={(e, page) => {
                  setFilterPayload({
                    ...filterPayload,
                    page: page,
                  });
                }}
              />
            </Stack>
          </div>
        </Container>
      </div>
    </Spinner>
  );
}

const mapStateToProps = (state) => ({
  user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
  dispatchFetchUserStats: (onSuccess, onError) =>
    dispatch(fetchUserStats(onSuccess, onError)),
  dispatchFetchMatchInvite: (type, onSuccess, onError) =>
    dispatch(FetchMatchInvite(type, onSuccess, onError)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MyInbox);
